import { render } from "./ReservationsManagement.vue?vue&type=template&id=567e7039"
import script from "./ReservationsManagement.vue?vue&type=script&lang=js"
export * from "./ReservationsManagement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__